import { ScoreOption } from '@/modules/teacher/SaitenList';
import _ from 'lodash';
import moment from 'moment';

/***************************
 * userの権限
 ***************************/
export enum RoleEnum {
  Admin = "admin",
  Teacher1 = "teacher1",
  Teacher2 = "teacher2",
  Student = "student",
  EntranceTeacher1 = "entrance_teacher1",
  EntranceTeacher2 = "entrance_teacher2",
  DigitalPaper = "digital_paper",
  PracticeExaminee = "p_examinee",
}

export enum RoleNameEnum {
  Admin = "システム管理者",
  Teacher1 = "管理者",
  Teacher2 = "一般",
  Student = "生徒",
  EntranceTeacher1 = "入試管理者",
  EntranceTeacher2 = "入試一般"
}

export interface ComboboxRole {
  value: string
  text: string
}

// プルダウン・ラジオボタン用 AdminとStudentは使用しない
export function GetComboboxRoleArray() :ComboboxRole[]{
  const rtn: ComboboxRole[] = [];
  rtn.push({value: RoleEnum.Teacher1, text: RoleNameEnum.Teacher1});
  rtn.push({value: RoleEnum.Teacher2, text: RoleNameEnum.Teacher2});
  rtn.push({value: RoleEnum.EntranceTeacher1, text: RoleNameEnum.EntranceTeacher1});
  rtn.push({value: RoleEnum.EntranceTeacher2, text: RoleNameEnum.EntranceTeacher2});
  return rtn;
}

// プルダウン・ラジオボタン用 AdminとStudentは使用しない
export function GetComboboxTeacherRoleArray() :ComboboxRole[]{
  const rtn: ComboboxRole[] = [];
  rtn.push({value: RoleEnum.Teacher1, text: RoleNameEnum.Teacher1});
  rtn.push({value: RoleEnum.Teacher2, text: RoleNameEnum.Teacher2});
  return rtn;
}

// プルダウン・ラジオボタン用 AdminとStudentは使用しない
export function GetComboboxEntranceTeacherRoleArray() :ComboboxRole[]{
  const rtn: ComboboxRole[] = [];
  rtn.push({value: RoleEnum.EntranceTeacher1, text: RoleNameEnum.EntranceTeacher1});
  rtn.push({value: RoleEnum.EntranceTeacher2, text: RoleNameEnum.EntranceTeacher2});
  return rtn;
}

/***************************
 * 学年
 ***************************/
export enum GradeEnum {
  Chu1 = 1,
  Chu2 = 2,
  Chu3 = 3,
  Kou1 = 4,
  Kou2 = 5,
  Kou3 = 6,
  Syo1 = 7,
  Syo2 = 8,
  Syo3 = 9,
  Syo4 = 10,
  Syo5 = 11,
  Syo6 = 12,
}

export enum GradeNameEnum {
  Chu1 = "中1",
  Chu2 = "中2",
  Chu3 = "中3",
  Kou1 = "高1",
  Kou2 = "高2",
  Kou3 = "高3",
  Syo1 = "小1",
  Syo2 = "小2",
  Syo3 = "小3",
  Syo4 = "小4",
  Syo5 = "小5",
  Syo6 = "小6",
}

export interface ComoboxGrade {
  value: number
  text: string
}

export function GetComboboxGradeArray() :ComoboxGrade[] {
  const rtn: ComoboxGrade[] = [];
  rtn.push({value: GradeEnum.Chu1, text: GradeNameEnum.Chu1});
  rtn.push({value: GradeEnum.Chu2, text: GradeNameEnum.Chu2});
  rtn.push({value: GradeEnum.Chu3, text: GradeNameEnum.Chu3});
  rtn.push({value: GradeEnum.Kou1, text: GradeNameEnum.Kou1});
  rtn.push({value: GradeEnum.Kou2, text: GradeNameEnum.Kou2});
  rtn.push({value: GradeEnum.Kou3, text: GradeNameEnum.Kou3});
  rtn.push({value: GradeEnum.Syo1, text: GradeNameEnum.Syo1});
  rtn.push({value: GradeEnum.Syo2, text: GradeNameEnum.Syo2});
  rtn.push({value: GradeEnum.Syo3, text: GradeNameEnum.Syo3});
  rtn.push({value: GradeEnum.Syo4, text: GradeNameEnum.Syo4});
  rtn.push({value: GradeEnum.Syo5, text: GradeNameEnum.Syo5});
  rtn.push({value: GradeEnum.Syo6, text: GradeNameEnum.Syo6});
  return rtn;
}

export function GetGradeNameByGrade(grade: number) :string {
  if(grade == GradeEnum.Chu1){
    return GradeNameEnum.Chu1;
  }else if(grade == GradeEnum.Chu2){
    return GradeNameEnum.Chu2;
  }else if(grade == GradeEnum.Chu3){
    return GradeNameEnum.Chu3;
  }else if(grade == GradeEnum.Syo1){
    return GradeNameEnum.Syo1;
  }else if(grade == GradeEnum.Syo2){
    return GradeNameEnum.Syo2;
  }else if(grade == GradeEnum.Syo3){
    return GradeNameEnum.Syo3;
  }else if(grade == GradeEnum.Syo4){
    return GradeNameEnum.Syo4;
  }else if(grade == GradeEnum.Syo5){
    return GradeNameEnum.Syo5;
  }else if(grade == GradeEnum.Syo6){
    return GradeNameEnum.Syo6;
  }else if(grade == GradeEnum.Kou1){
    return GradeNameEnum.Kou1;
  }else if(grade == GradeEnum.Kou2){
    return GradeNameEnum.Kou2;
  }else if(grade == GradeEnum.Kou3){
    return GradeNameEnum.Kou3;
  }else{
    return "";
  }
}

/***************************
 * 実施月 プルダウン用
 ***************************/
export interface ComoboxMonth {
  value: number
  text: string
}

export function GetComboboxMonthArray() :ComoboxMonth[] {
  const rtn: ComoboxMonth[] = [];
  rtn.push({value: 1, text: "1月"});
  rtn.push({value: 2, text: "2月"});
  rtn.push({value: 3, text: "3月"});
  rtn.push({value: 4, text: "4月"});
  rtn.push({value: 5, text: "5月"});
  rtn.push({value: 6, text: "6月"});
  rtn.push({value: 7, text: "7月"});
  rtn.push({value: 8, text: "8月"});
  rtn.push({value: 9, text: "9月"});
  rtn.push({value: 10, text: "10月"});
  rtn.push({value: 11, text: "11月"});
  rtn.push({value: 12, text: "12月"});
  return rtn;
}

/***************************
 * 学校ごとに付与されるオプション情報
 ***************************/
export enum SchoolOptionEnum {
  StudentManage = 1,
  Cbt = 2,
  Entrance = 3,
  TwoFactor = 4,
  Classroom = 5,
  DigitalPaper = 6,
  MailReturn = 7,
  Practice = 8,
}

/***************************
 * 試験種別
 ***************************/
export enum SheetTypeEnum {
  Normal = 0,
  Cbt = 1,
  Entrance = 2,
  Practice = 3,
}

/***************************
 * API連携種別Api
 ***************************/
export enum ApiTypeEnum {
  None = 0,
  Classroom = 1,
  Teams = 2,
}

/***************************
 * sheet_field.kind Enum
 * api側のConstantsと同じ定義にすること
 ***************************/
export enum SheetFieldKindEnum {
  FIELD = 0,
  TOTAL_SCORE = 10,
  PART1 = 11,
  VIEW_POINT = 12,
  STUDENT_INFO = 9,
}

/***************************
 * sheet_field.scoring_type Enum
 * api側のConstantsと同じ定義にすること
 ***************************/
 export enum ScoringTypeEnum {
  Seigo = 1,
  ScoreStampPlus = 2,
  ScoreStampMinus = 3,
}

/***************************
 * scoring_type プルダウン用
 ***************************/
 export interface ComoboxScoingType {
  value: number
  text: string
}

export function GetComboboxScoingTypeArray() :ComoboxScoingType[] {
  const rtn: ComoboxScoingType[] = [];
  rtn.push({value: ScoringTypeEnum.Seigo, text: GetScoringTypeNameByCode(ScoringTypeEnum.Seigo)});
  rtn.push({value: ScoringTypeEnum.ScoreStampPlus, text: GetScoringTypeNameByCode(ScoringTypeEnum.ScoreStampPlus)});
  rtn.push({value: ScoringTypeEnum.ScoreStampMinus, text: GetScoringTypeNameByCode(ScoringTypeEnum.ScoreStampMinus)});
  return rtn;
}

export function IsScoringTypeScoreStamp(scoring_type: number) :boolean {
  return scoring_type == ScoringTypeEnum.ScoreStampPlus || scoring_type == ScoringTypeEnum.ScoreStampMinus
}

export function GetScoringTypeNameByCode(code: number){
  let rtn = "";
  if(code == ScoringTypeEnum.Seigo){
    rtn = "標準方式";
  }else if(code == ScoringTypeEnum.ScoreStampPlus){
    rtn = "加点スタンプ方式";
  }else if(code == ScoringTypeEnum.ScoreStampMinus){
    rtn = "減点スタンプ方式";
  }
  return rtn;
}

/***************************
 * 正答 プルダウン用
 ***************************/
 export interface ComoboxCorrectText {
  value: string
  text: string
}

export function GetComboboxCorrectTextArray() :ComoboxCorrectText[] {
  const rtn: ComoboxCorrectText[] = [];
  rtn.push({value: "ア", text: "ア"});
  rtn.push({value: "イ", text: "イ"});
  rtn.push({value: "ウ", text: "ウ"});
  rtn.push({value: "エ", text: "エ"});
  rtn.push({value: "オ", text: "オ"});
  rtn.push({value: "カ", text: "カ"});
  rtn.push({value: "キ", text: "キ"});
  rtn.push({value: "ク", text: "ク"});
  rtn.push({value: "ケ", text: "ケ"});
  rtn.push({value: "コ", text: "コ"});
  rtn.push({value: "0", text: "0"});
  rtn.push({value: "1", text: "1"});
  rtn.push({value: "2", text: "2"});
  rtn.push({value: "3", text: "3"});
  rtn.push({value: "4", text: "4"});
  rtn.push({value: "5", text: "5"});
  rtn.push({value: "6", text: "6"});
  rtn.push({value: "7", text: "7"});
  rtn.push({value: "8", text: "8"});
  rtn.push({value: "9", text: "9"});
  return rtn;
}

/***************************
 * sheet_field.answer_type Enum
 * api側のConstantsと同じ定義にすること
 ***************************/
 export enum DigialAnswerTypeEnum {
  Both = 1,
  Draw = 2,
  Text = 3,
}

export interface ComoboxDigitalAnswerType {
  value: number
  text: string
}

export function GetComboboxDigitalAnswerTypeArray() :ComoboxDigitalAnswerType[] {
  const rtn: ComoboxDigitalAnswerType[] = [];
  rtn.push({value: DigialAnswerTypeEnum.Both, text: GetDigitalAnswerTypeNameByCode(DigialAnswerTypeEnum.Both)});
  rtn.push({value: DigialAnswerTypeEnum.Draw, text: GetDigitalAnswerTypeNameByCode(DigialAnswerTypeEnum.Draw)});
  rtn.push({value: DigialAnswerTypeEnum.Text, text: GetDigitalAnswerTypeNameByCode(DigialAnswerTypeEnum.Text)});
  return rtn;
}

export function GetDigitalAnswerTypeNameByCode(code: number){
  let rtn = "";
  if(code == DigialAnswerTypeEnum.Both){
    rtn = "手書き・テキスト";
  }else if(code == DigialAnswerTypeEnum.Draw){
    rtn = "手書きのみ";
  }else if(code == DigialAnswerTypeEnum.Text){
    rtn = "テキスト";
  }
  return rtn;
}

/***************************
 * practice_ecaminee.applied_type Enum
 * api側のConstantsと同じ定義にすること
 ***************************/
 export enum AppliedTypeEnum {
  Single = 1,
  Multi = 2,
}

export interface ComoboxAppliedType {
  value: number
  text: string
}

export function GetComboboxAppliedTypeArray() :ComoboxAppliedType[] {
  const rtn: ComoboxAppliedType[] = [];
  rtn.push({value: AppliedTypeEnum.Single, text: GetAppliedTypeNameByCode(AppliedTypeEnum.Single)});
  rtn.push({value: AppliedTypeEnum.Multi, text: GetAppliedTypeNameByCode(AppliedTypeEnum.Multi)});
  return rtn;
}

export function GetAppliedTypeNameByCode(code: number){
  let rtn = "";
  if(code == AppliedTypeEnum.Single){
    rtn = "専願";
  }else if(code == AppliedTypeEnum.Multi){
    rtn = "併願";
  }
  return rtn;
}

/***************************
 * sumup_unit.unit_type Enum
 * api側のConstantsと同じ定義にすること
 ***************************/
 export enum SumupUnitTypeEnum {
  SingleCurriculum = 1,
  MultiCurriculum = 2,
  MultiUnit = 3,
}

export interface ComoboxSumupUnitType {
  value: number
  text: string
}

/***************************
 * sumup_group.assessment_score_type Enum
 * api側のConstantsと同じ定義にすること
 ***************************/
 export enum AssessmentScoreTypeEnum {
  TotalScore = 1,
  StdScore = 2,
}

export interface ComoboxAssessmentScoreType {
  value: number
  text: string
}

export function GetComboboxAssessmentScoreTypeArray() :ComoboxAssessmentScoreType[] {
  const rtn: ComoboxAssessmentScoreType[] = [];
  rtn.push({value: AssessmentScoreTypeEnum.TotalScore, text: GetAssessmentScoreTypeNameByCode(AssessmentScoreTypeEnum.TotalScore)});
  rtn.push({value: AssessmentScoreTypeEnum.StdScore, text: GetAssessmentScoreTypeNameByCode(AssessmentScoreTypeEnum.StdScore)});
  return rtn;
}

export function GetAssessmentScoreTypeNameByCode(code: number){
  let rtn = "";
  if(code == AssessmentScoreTypeEnum.TotalScore){
    rtn = "得点";
  }else if(code == AssessmentScoreTypeEnum.StdScore){
    rtn = "偏差値";
  }
  return rtn;
}

/***************************
 * 中学入試総合教科用
 ***************************/

 export enum SougouCurriculumIdEnum {
  Two = 102,
  Three = 103,
  Four = 104,
}

export enum SougouCurriculumNameEnum {
  Two = "総合(2科)",
  Three = "総合(3科)",
  Four = "総合(4科)",
}

export enum PassingStateEnum {
  Fail = 0,
  Sub = 1,
  Pass = 2
}

/***************************
 * API Getのクエリ生成
 ***************************/
export function BuildQuery(object: any, namespace: string) :string {
  return _.map(object, (value: any, key: any) => {
    return namespace ? `${namespace}[${encodeURIComponent(key)}]=${encodeURIComponent(value)}` : `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  }).join('&');
}

/***************************
 * 時刻を指定されたフォーマットに変換
 ***************************/
export function formatDate(value: any, format: string) :string {
  if (value === null || value === "") {
    return "";
  }
  var datetimeAt = new Date(value);
  return moment(datetimeAt).format(format);
}

/***************************
 * 数字配列の合計値を取得
 ***************************/
export function sumArray(array: number[]) {
  let sum = 0;
  for (let i = 0, len = array.length; i < len; i++) {
    sum += array[i];
  }
  return sum;
}

/***************************
 * 試験一覧のページあたりの行数
 ***************************/
export const SheetListRowCount = 20;

/***************************
 * スクロール
 ***************************/
export function smoothScroll(fromTop: number, toTop: number, fromLeft: number, toLeft: number, elem: HTMLElement): Promise<void> {
  const duration = 300; // アニメーションの時間（ミリ秒）
  const framesPerSecond = 60; // 1秒あたりのフレーム数
  const frameInterval = 1000 / framesPerSecond; // フレームの間隔（ミリ秒）

  let scrollLeft = fromLeft;
  let scrollTop = fromTop;

  const rangeH = (toTop - fromTop) / (duration / frameInterval);
  const rangeV = (toLeft - fromLeft) / (duration / frameInterval);

  return new Promise<void>(resolve => {
    const move = function () {
      if ((rangeH > 0 && scrollTop + rangeH > toTop) || (rangeH < 0 && scrollTop + rangeH < toTop)) {
        scrollTop = toTop;
      } else {
        scrollTop += rangeH;
      }

      if ((rangeV > 0 && scrollLeft + rangeV > toLeft) || (rangeV < 0 && scrollLeft + rangeV < toLeft)) {
        scrollLeft = toLeft;
      } else {
        scrollLeft += rangeV;
      }

      // スクロールさせる
      elem.scrollTo(scrollLeft, scrollTop);

      // 現在位置が目的位置より進んでいなければアニメーションを続行させる
      if ((rangeH > 0 && scrollTop < toTop) || (rangeH < 0 && scrollTop > toTop) || (rangeV > 0 && scrollLeft < toLeft) || (rangeV < 0 && scrollLeft > toLeft)) {
        setTimeout(move, frameInterval);
      } else {
        resolve();
      }
    };
    move(); // 初回呼び出し
  });
}

/**
 * 整数チェック
 * @param value 
 */
export const isInteger = (value: string): boolean => {

  if (!value) {
    return false;
  }

  const number = Number(value);

  return !isNaN(number) && isFinite(number) && (value.toString().length == parseInt(value).toString().length) && (value.toString().indexOf(".") == -1);
}

/**
 * 浮動小数点チェック
 * @param value
 * @returns 
 */
export const isFloat = (value: string): boolean => {
  const regex = /^[+-]?[0-9]+\.[0-9]+([eE][+-]?[0-9]+)?$/;
  return regex.test(value);
}

/**
 * 整数 or 浮動小数点数かチェック
 * @param value 
 */
export const isFloatOrInteger = (value: string): boolean => {
  return isInteger(value) || isFloat(value);
}

/**
 * ファイル名から拡張子取得
 * @param fileName 
 * @returns 
 */
export const getFileExtension = (fileName: string) => {
  var fileNameSplitArray = fileName.split('.');

  if(fileNameSplitArray.length == 1){
    return "";
  }else{
    return fileNameSplitArray[fileNameSplitArray.length - 1].toLowerCase();
  }
}

/************************************************************
 * Windowsのフォルダ名前順ソートロジックで並び替え
 * StrCmpLogicalW 関数を再現
 ************************************************************/

export const strCmpLogicalW = (str1: string, str2: string): number => {
  // 数値部分を抽出する正規表現パターンを定義
  const pattern = /(\d+)|(\D+)/g;
  
  // 文字列を数値部分と非数値部分に分割する
  const parts1 = str1.match(pattern) ?? [];
  const parts2 = str2.match(pattern) ?? [];
  
  // 数値部分を数値に変換して、文字列の比較を行う
  for (let i = 0; i < parts1.length && i < parts2.length; i++) {
    const part1 = parts1[i];
    const part2 = parts2[i];
    
    if (/\d/.test(part1) && /\d/.test(part2)) {
      // 数値部分同士の比較
      const num1 = parseInt(part1, 10);
      const num2 = parseInt(part2, 10);
      if (num1 !== num2) {
        return num1 < num2 ? -1 : 1;
      }
    } else {
      // 非数値部分同士の比較
      if (part1 !== part2) {
        return part1 < part2 ? -1 : 1;
      }
    }
  }
  
  // 全ての部分が同じ場合は、長さで比較する
  return str1.length - str2.length;
}


/************************************************************
 * テキスト画像サイズ取得時に使用する定数
 ************************************************************/

 export const lineScale = 1.1618;

 /************************************************************
  * テキスト画像のサイズ取得
  ************************************************************/
 
  export const getTextSize = (text: string, fontSize: number, lineHeight: number, defaultText: string = "テキスト") => {
   text = text ? text : defaultText;
   const canvas = document.createElement('canvas') as HTMLCanvasElement;
   const ctx = canvas.getContext('2d');
   ctx.font = `${fontSize}px serif`;
 
   let width = 0;
   let height = 0;
   const lines = text.split("\n");
 
   for(let i = 0; i < lines.length; i++){
     const metrics = ctx.measureText(lines[i]);
     width = metrics.width > width ? metrics.width : width;
     height += Number(fontSize) * lineScale;
     height += i == lines.length - 1 ? 0 : Number(lineHeight);
   }
   height += Number(fontSize) * (lineScale - 1);
 
   return new Size(width, height);
 }

 /************************************************************
 * テキスト画像のBase64生成
 ************************************************************/

export const createBase64Text = (obj: any, defaultText: string = "テキスト") => {
  const text = obj.text ? obj.text : defaultText;
  const canvas = document.createElement('canvas') as HTMLCanvasElement;
  canvas.width = obj.width;
  canvas.height = obj.height;
  const ctx = canvas.getContext('2d');
  ctx.font = `${obj.font_size}px serif`;
  ctx.fillStyle = obj.color;
  let y = 0;
  const lines = text.split("\n");
  for(let i = 0; i < lines.length; i++){
    y += i == 0 ? Number(obj.font_size) : Number(obj.font_size) * lineScale;
    ctx.fillText(lines[i], 0, y);
    y += Number(obj.line_height);
  }
  return canvas.toDataURL("image/png").replace("data:image/png;base64,", "");
}

export class Size {
  width: number
  height: number
  
  constructor(width: number, height: number){
    this.width = width;
    this.height = height;
  }
}

export class Point {
  x: number
  y: number
  
  constructor(x: number, y: number){
    this.x = x;
    this.y = y;
  }
}

export const customAlert = async (bvModal: any, store: any, msg: string) => {
  store.commit("setIsShowingMsgBox", true);
  const result =  await bvModal.msgBoxOk(msg, {autoFocusButton: "ok", id: "msg-box"});
  store.commit("setIsShowingMsgBox", false);
  return result;
}

export const customConfirm = async (bvModal: any, store: any, msg: string, title: string = "確認") => {
  store.commit("setIsShowingMsgBox", true);
  const result =  await bvModal.msgBoxConfirm(msg, {autoFocusButton: "ok", id: "msg-box", title: title});
  store.commit("setIsShowingMsgBox", false);
  return result;
}

export const getCookieValue = (cookies: any, key: string) => {
  
  let rtn: string = null;
  const cookiesArray = cookies.split(';');
  for(let c of cookiesArray){
    const cArray = c.split('=');
    if(cArray[0].trim() == key){
      rtn = cArray[1];
    }
  }
  return rtn;
}

export const arraySplit = <T = object>(array: T[], n: number): T[][] => {
  return array.reduce((acc: T[][], c, i: number) => (i % n ? acc : [...acc, ...[array.slice(i, i + n)]]), []);
}

export const showToast = (bvToast: any, msg: string, title: string = "処理完了", isError = false) => {
  bvToast.toast(msg, {
    variant: isError ? "denger" : "success",
    title: title,
    autoHideDelay: 3000,
    autoHide: true,
    appendToast: true,
    solid: true,
    toaster: "b-toaster-bottom-right",
  })
}